import { DeleteQueueRequestComment } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteDeleteQueueRequestComment
  extends BaseHttpService<DeleteQueueRequestComment.Model>
  implements DeleteQueueRequestComment
{
  async delete(): Promise<DeleteQueueRequestComment.Model> {
    return await this.request('delete');
  }
}
